import { XOR } from '../../types'

export type Icon = React.ReactNode

export enum Variant {
  TRANSPARENT,
  WHITE,
  BLUE,
  BLACK,
  STROKED
}

export enum Size {
  LARGE,
  MEDIUM,
  SMALL
}

/** @NOTE Этот enum определяет ширину кнопки.
 *  - NARROW: соответствует узкой кнопке (ширина: fit-content).
 *  - WIDE: соответствует широкой кнопке (ширина: auto).
 *
 *  В макете был такой вариант (Wide)
 */

export enum Width {
  NARROW = 'NARROW',
  WIDE = 'WIDE'
}

export type Props = {
  size?: Size
  variant?: Variant
  width?: Width
  isLoading?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
  XOR<{ iconLeft?: React.ReactNode; iconRight?: React.ReactNode; icon?: React.ReactNode }>

export type StaticProps = {
  Size: typeof Size
  Variant: typeof Variant
  Width: typeof Width
}
